@let chatbotChannels = channelsService.chatbotChannels();

<!-- error -->
@if (chatbotChannels.length >= userService.getChannelLimit()) {
  <p
    class="mb-5 py-3 px-4 border border-solid rounded-md bg-red-400/10 flex items-center gap-3 border-red-400 text-white">
    <span class="material-symbols-rounded text-red-400 min-w-fit">warning</span>
    O limite de números conectados para seu plano ({{
      userService.getChannelLimit()
    }}) foi atingido.
    <a
      class="font-bold text-accent-500 min-w-fit ml-auto"
      target="_blank"
      href="https://wa.me/5531933005090?text=Olá%2C+gostaria+de+contratar+mais+números"
      >Adquirir mais</a
    >
  </p>
}

<!-- show CTA if limit is 0   -->
@if (userService.getAgentLimit() === 0) {
  <p
    class="mb-5 py-3 px-4 border border-solid rounded-md bg-accent-400/10 flex md:items-center gap-3 border-accent-600 text-white">
    <span class="material-symbols-rounded text-accent-400 min-w-fit">info</span>
    Você está usando uma versão teste dos Agentes I.A. Adicione agentes a sua
    assinatura para aumentar o limite de mensagens.
    <a
      class="font-bold text-accent-500 min-w-fit ml-auto"
      target="_blank"
      href="https://wa.me/5531933005090?text=Olá%2C+gostaria+de+contratar+mais+agentes"
      >Adquirir</a
    >
  </p>
} @else if (!canAddAgent()) {
  <!-- show error if agent limit exceeded -->
  <p
    class="mb-5 py-3 px-4 border border-solid rounded-md bg-red-400/10 flex md:items-center gap-3 border-red-400 text-white">
    <span class="material-symbols-rounded text-red-400 min-w-fit">warning</span>
    O limite de agentes I.A. para seu plano ({{ userService.getAgentLimit() }})
    foi atingido.
    <a
      class="font-bold text-accent-500 min-w-fit ml-auto"
      target="_blank"
      href="https://wa.me/5531933005090?text=Olá%2C+gostaria+de+contratar+mais+agentes"
      >Adquirir mais</a
    >
  </p>
}

<section class="card min-h-full">
  <!-- header -->
  <h2 class="flex items-center gap-3">
    <span class="material-symbols-rounded text-accent-600">
      phonelink_ring
    </span>
    Números conectados ({{ chatbotChannels.length }}/{{
      userService.getChannelLimit()
    }})
    <button
      [routerLink]="[{ outlets: { modal: ['add', ''] } }]"
      class="ml-auto tertiary !px-1 md:!px-3"
      [disabled]="chatbotChannels.length >= userService.getChannelLimit()">
      <span class="material-symbols-rounded m-auto text-black/60"> add </span>
      @if (sharedService.screenSize !== 's') {
        Adicionar
      }
    </button>
  </h2>

  <!-- body -->
  @if (chatbotChannels.length > 0) {
    <p class="text-balance text-black/60">
      Conecte números e os ative como uma sessão do WhatsApp Web. Vincule
      agentes, fluxos ou atendentes a um número conectado para habilitar acesso e respostas
      automáticas.
      <a
        href="https://home.blu.direct/blog/visao-geral-chatbot#criando-e-vinculando-um-canal"
        target="_blank"
        class="font-bold text-accent-600"
        >Saiba mais</a
      >
    </p>

    <!-- feature tags -->
    <div class="flex gap-1 flex-wrap mb-4">
      <div 
        class="blu-tag cursor-pointer" 
        [class.active]="activeFilter() === 'agents'"
        (click)="toggleFilter('agents')">
        <span class="material-symbols-rounded" [class.!text-accent-600]="activeFilter() === 'agents'">smart_toy</span>
        Agentes 
      </div>
      <div 
        class="blu-tag cursor-pointer"
        [class.active]="activeFilter() === 'flows'"
        (click)="toggleFilter('flows')">
        <span class="material-symbols-rounded" [class.!text-accent-600]="activeFilter() === 'flows'">account_tree</span>
        Fluxos
      </div>
      <div 
        class="blu-tag cursor-pointer"
        [class.active]="activeFilter() === 'operators'"
        (click)="toggleFilter('operators')">
        <span class="material-symbols-rounded" [class.!text-accent-600]="activeFilter() === 'operators'">support_agent</span>
        Atendentes
      </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      @for (channel of filteredChannels(); track channel) {
        <blu-channel-card
          [channel]="channel"
          [canAddAgent]="canAddAgent"></blu-channel-card>
      }
    </div>
  } @else {
    <!-- empty state -->
    <div
      class="max-w-80 min-h-80 text-center flex flex-col items-center gap-4 justify-center m-auto">
      <h1>Conecte seu primeiro número</h1>
      <p class="leading-snug text-black/60">
        Conecte números e os ative como uma sessão do WhatsApp Web. Vincule
        agentes, fluxos ou atendentes a um número para habilitar acesso e
        respostas automáticas.
      </p>

      <a
        href="https://home.blu.direct/blog/visao-geral-chatbot#criando-e-vinculando-um-canal"
        target="_blank"
        class="no-underline">
        <button class="secondary">Saiba mais</button>
      </a>
    </div>
  }
</section>

<!-- modals -->
<router-outlet name="modal"></router-outlet>
